<template>
    <div class="el-main-wrapper manage-container" v-if="checked">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">Containers</h1>
        </el-row>

        <div class="el-main-content">
            <div class="el-grid-card">
                <div class="el-grid-card__header">
                    {{ $t('title.overview') }}
                </div>
                <div class="el-grid-card__body mb-10">
                    <el-row :gutter="100">
                        <el-col :span="8">
                            <el-tree
                                :data="containerTree"
                                :props="container.defaultProps"
                                :default-checked-keys="[checked.ContainerID]"
                                :default-expanded-keys="[checked.ContainerID]"
                                :node-key="container.nodeKey"
                                highlight-current
                                @node-drop="handleDrop"
                                draggable
                                accordion
                                @node-click="checkSelected"
                            >
                                <span
                                    class="custom-tree-node"
                                    slot-scope="{ node, data }"
                                >
                                    <span>{{ node.label }}</span>
                                    <span>
                                        <v-btn
                                            v-if="
                                                permissions.includes(
                                                    'CONTAINER_WRITE'
                                                )
                                            "
                                            icon
                                            small
                                            @click.stop="
                                                () =>
                                                    startAddingNewContainer(
                                                        data
                                                    )
                                            "
                                        >
                                            <v-icon color="blue">add</v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="
                                                permissions.includes(
                                                    'CONTAINER_DELETE'
                                                )
                                            "
                                            icon
                                            small
                                            @click="() => deleteContainer(data)"
                                        >
                                            <v-icon color="pink">delete</v-icon>
                                        </v-btn>
                                    </span>
                                </span>
                            </el-tree>
                        </el-col>

                        <el-col :span="14">
                            <el-row class="el-title-block">
                                <div class="text-xl">
                                    {{ $t('form.label.container') }}
                                    <small class="text-grey-dark"
                                        >: {{ checked.Description }}</small
                                    >
                                </div>
                            </el-row>

                            <v-tabs>
                                <v-tab>Settings</v-tab>
                                <v-tab>Custom Fields</v-tab>
                                <v-tab v-if="isSystemAdmin">{{
                                    $t('form.label.selfCheckin.title')
                                }}</v-tab>
                                <v-tab>{{
                                    $t('form.label.postalAddress')
                                }}</v-tab>
                                <v-tabs-items>
                                    <v-tab-item>
                                        <v-card
                                            class="my-3 mx-2"
                                            style="
                                                position: relative;
                                                left: -7px;
                                            "
                                        >
                                            <v-card-text>
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.containerDescription'
                                                        )
                                                    "
                                                    multiple
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.Description
                                                    "
                                                ></v-text-field>
                                                <v-select
                                                    :items="containerTypes"
                                                    :label="
                                                        $t(
                                                            'form.label.containerType'
                                                        )
                                                    "
                                                    item-text="Description"
                                                    item-value="Description"
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.ContainerType
                                                    "
                                                >
                                                </v-select>
                                                <v-select
                                                    :items="types"
                                                    :label="
                                                        $t('form.label.type')
                                                    "
                                                    multiple
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.AvailableBookingTypes
                                                    "
                                                    chips
                                                >
                                                </v-select>
                                                <v-select
                                                    :items="bookingTimes"
                                                    :label="
                                                        $t(
                                                            'form.label.minimumBookingTime'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.MinimumBookingTime
                                                    "
                                                >
                                                </v-select>
                                                <v-text-field
                                                    type="number"
                                                    min="0"
                                                    :label="
                                                        $t(
                                                            'form.label.maxPassesPerBooking'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.MaximumPassingsPerBooking
                                                    "
                                                />
                                                <v-text-field
                                                    type="number"
                                                    min="0"
                                                    :label="
                                                        $t(
                                                            'form.label.defaultWATime'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.DefaultWATime
                                                    "
                                                />
                                                <v-checkbox
                                                    style="margin-top: 50px"
                                                    :label="
                                                        $t(
                                                            'form.label.autoPinEnabled'
                                                        )
                                                    "
                                                    color="success"
                                                    v-model="
                                                        checked.AutoPinEnabled
                                                    "
                                                    class="checkbox-primary"
                                                    hide-details
                                                />
                                                <v-checkbox
                                                    :label="
                                                        $t(
                                                            'form.label.canBookOverlapped'
                                                        )
                                                    "
                                                    color="success"
                                                    v-model="
                                                        checked.IsBookingCanOverlapped
                                                    "
                                                    class="checkbox-primary"
                                                    hide-details
                                                >
                                                </v-checkbox>

                                                <div
                                                    class="mt-3 button-wrapper flex justify-between items-center"
                                                >
                                                    <v-btn
                                                        round
                                                        v-if="editing"
                                                        :disabled="loading"
                                                        class="primary"
                                                        @click.prevent="
                                                            () =>
                                                                updateContainer(
                                                                    checked
                                                                )
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                'button.text.update'
                                                            )
                                                        }}
                                                    </v-btn>
                                                    <v-btn
                                                        v-if="!editing"
                                                        round
                                                        :disabled="loading"
                                                        class="primary"
                                                        @click.prevent="
                                                            () =>
                                                                addNewContainer()
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                'button.text.save'
                                                            )
                                                        }}
                                                    </v-btn>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <div class="flex justify-end">
                                            <v-btn
                                                small
                                                color="primary"
                                                class="mt-3 mx-2 w-auto"
                                                type="button"
                                                @click="
                                                    () =>
                                                        addCustomFiled(
                                                            checked.ContainerID
                                                        )
                                                "
                                                >New</v-btn
                                            >
                                        </div>
                                        <form
                                            v-loading="pageLoading"
                                            style="min-height: 300px"
                                        >
                                            <div
                                                v-for="(
                                                    customField, index
                                                ) in customFields"
                                                :key="index"
                                            >
                                                <v-card
                                                    class="my-3 mx-2 pl-10 pr-6 pt-6 pb-2"
                                                    style="
                                                        position: relative;
                                                        left: -7px;
                                                    "
                                                >
                                                    <div
                                                        class="flex justify-between"
                                                    >
                                                        <div class="w-5/6">
                                                            <v-text-field
                                                                label="Field Name"
                                                                class="input-bg-light"
                                                                v-model="
                                                                    customField.FieldName
                                                                "
                                                                :name="
                                                                    index +
                                                                    customField.FieldName
                                                                "
                                                                required
                                                            ></v-text-field>
                                                            <v-text-field
                                                                label="Field Value"
                                                                class="input-bg-light"
                                                                v-model="
                                                                    customField.FieldValue
                                                                "
                                                                :name="
                                                                    index +
                                                                    customField.FieldValue
                                                                "
                                                                required
                                                            ></v-text-field>
                                                        </div>
                                                        <div class="w-1/6">
                                                            <div
                                                                class="flex justify-end"
                                                            >
                                                                <div
                                                                    class="w-10"
                                                                >
                                                                    <button
                                                                        class="w-10 text-right mb-2"
                                                                        type="button"
                                                                        :disabled="
                                                                            loading
                                                                        "
                                                                        @click="
                                                                            () =>
                                                                                removeCustomFiled(
                                                                                    customField,
                                                                                    index
                                                                                )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            color="red"
                                                                            >delete</v-icon
                                                                        >
                                                                    </button>
                                                                    <button
                                                                        class="w-10 text-right"
                                                                        type="button"
                                                                        :disabled="
                                                                            loading
                                                                        "
                                                                        @click="
                                                                            () =>
                                                                                saveCustomField(
                                                                                    customField
                                                                                )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            color="green"
                                                                            >check</v-icon
                                                                        >
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-card>
                                            </div>
                                        </form>
                                    </v-tab-item>
                                    <v-tab-item v-if="isSystemAdmin">
                                        <form
                                            v-loading="pageLoading"
                                            style="min-height: 300px"
                                        >
                                            <v-card
                                                class="my-3 mx-2 pl-10 pr-6 pt-6 pb-2"
                                                style="
                                                    position: relative;
                                                    left: -7px;
                                                "
                                            >
                                                <v-checkbox
                                                    v-if="isCCCContainer"
                                                    :label="
                                                        $t(
                                                            'form.label.selfCheckin.showUnplannedDelivery'
                                                        )
                                                    "
                                                    color="success"
                                                    v-model="
                                                        checked.ShowUnplannedDelivery
                                                    "
                                                    class="checkbox-primary"
                                                    hide-details
                                                />
                                                <v-select
                                                    :items="
                                                        checkpointAccessSchedules
                                                    "
                                                    :label="
                                                        $t(
                                                            'form.label.defaultCheckpointAccessSchedule'
                                                        )
                                                    "
                                                    item-text="Description"
                                                    item-value="ScheduleTemplateID"
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.DefaultCpAccessSchedule
                                                    "
                                                >
                                                </v-select>
                                                <v-text-field
                                                    v-if="isCCCContainer"
                                                    :label="
                                                        $t(
                                                            'form.label.selfCheckin.customHeaderEN'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.CustomHeaderTextEn
                                                    "
                                                ></v-text-field>
                                                <v-text-field
                                                    v-if="isCCCContainer"
                                                    :label="
                                                        $t(
                                                            'form.label.selfCheckin.customHeaderSV'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.CustomHeaderTextSv
                                                    "
                                                ></v-text-field>
                                                <v-checkbox
                                                    v-if="!isCCCContainer"
                                                    :label="
                                                        $t(
                                                            'form.label.selfCheckin.allowed'
                                                        )
                                                    "
                                                    color="success"
                                                    v-model="
                                                        checked.IsAllowedSelfCheckin
                                                    "
                                                    class="checkbox-primary"
                                                    hide-details
                                                />
                                                <el-row>
                                                    <el-col
                                                        :span="5"
                                                        style="margin-top: 14px"
                                                    >
                                                        <span
                                                            style="
                                                                color: #989ea7;
                                                            "
                                                            >{{
                                                                $t(
                                                                    'form.label.selfCheckin.customLogo'
                                                                )
                                                            }}</span
                                                        >
                                                    </el-col>
                                                    <el-col :span="19">
                                                        <stc-file-gallery
                                                            :multiple="false"
                                                            fileTypesAccept="image/jpeg,image/png"
                                                            buttonText="form.label.select"
                                                            @selected-files="
                                                                onSelectedFiles
                                                            "
                                                            :displayFiles="
                                                                displayFiles
                                                            "
                                                        ></stc-file-gallery>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <div
                                                        class="el-form-card__element-wrapper"
                                                    >
                                                        <v-radio-group
                                                            v-if="
                                                                !isCCCContainer
                                                            "
                                                            v-model="isUserMode"
                                                            row
                                                        >
                                                            <v-radio
                                                                :label="
                                                                    $t(
                                                                        'form.title.user'
                                                                    )
                                                                "
                                                                value="user"
                                                                color="primary"
                                                            ></v-radio>
                                                            <v-radio
                                                                :label="
                                                                    $t(
                                                                        'form.title.userGroup'
                                                                    )
                                                                "
                                                                value="userGroup"
                                                                color="primary"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </div>
                                                </el-row>
                                                <div
                                                    v-if="!isCCCContainer"
                                                    v-show="
                                                        isUserMode === 'user'
                                                    "
                                                >
                                                    <el-row>
                                                        <v-select
                                                            v-if="
                                                                permissions.includes(
                                                                    'USER_READ'
                                                                )
                                                            "
                                                            :items="recipients"
                                                            item-text="Label"
                                                            combobox
                                                            return-object
                                                            v-model="
                                                                selfCheckinData.user
                                                            "
                                                            :label="
                                                                $t(
                                                                    'form.label.recipientName'
                                                                )
                                                            "
                                                            dark
                                                            clearable
                                                        >
                                                        </v-select>
                                                    </el-row>
                                                </div>

                                                <div
                                                    v-if="!isCCCContainer"
                                                    v-show="
                                                        isUserMode ===
                                                        'userGroup'
                                                    "
                                                >
                                                    <el-row>
                                                        <v-select
                                                            :items="userGroups"
                                                            item-text="GroupName"
                                                            item-value="UserGroupID"
                                                            return-object
                                                            v-model="
                                                                selfCheckinData.userGroup
                                                            "
                                                            :label="
                                                                $t(
                                                                    'form.title.userGroup'
                                                                )
                                                            "
                                                            dark
                                                            clearable
                                                            combobox
                                                        >
                                                        </v-select>
                                                    </el-row>
                                                </div>
                                                <div>
                                                    <v-select
                                                        v-if="!isCCCContainer"
                                                        :items="
                                                            activeUnloadingAreas
                                                        "
                                                        item-text="ShortDescription"
                                                        item-value="UnloadingAreaID"
                                                        return-object
                                                        v-model="
                                                            selfCheckinData.unloadingArea
                                                        "
                                                        :label="
                                                            $t(
                                                                'form.label.unloadingArea'
                                                            )
                                                        "
                                                        dark
                                                        clearable
                                                        combobox
                                                    >
                                                    </v-select>
                                                </div>
                                                <div>
                                                    <v-select
                                                        v-if="!isCCCContainer"
                                                        :items="waitingAreas"
                                                        item-text="Description"
                                                        item-value="WaitingAreaID"
                                                        return-object
                                                        v-model="
                                                            checked.DefaultWaitingArea
                                                        "
                                                        :label="
                                                            $t(
                                                                'form.label.selectWaitingArea'
                                                            )
                                                        "
                                                        dark
                                                        clearable
                                                        combobox
                                                    >
                                                    </v-select>
                                                </div>
                                                <v-btn
                                                    small
                                                    color="primary"
                                                    class="mt-3 mx-2 w-auto"
                                                    type="button"
                                                    :disabled="loading"
                                                    @click.stop="
                                                        updateSelfCheckin(
                                                            checked,
                                                            selfCheckinData
                                                        )
                                                    "
                                                    >{{
                                                        $t('button.text.update')
                                                    }}</v-btn
                                                >
                                            </v-card>
                                        </form>
                                    </v-tab-item>
                                    <v-tab-item>
                                        <v-card
                                            class="my-3 mx-2"
                                            style="
                                                position: relative;
                                                left: -7px;
                                            "
                                        >
                                            <v-card-text>
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.address.address1'
                                                        )
                                                    "
                                                    multiple
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.AddressLine1
                                                    "
                                                ></v-text-field>
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.address.address2'
                                                        )
                                                    "
                                                    multiple
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.AddressLine2
                                                    "
                                                ></v-text-field>
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.address.zipCode'
                                                        )
                                                    "
                                                    multiple
                                                    class="input-bg-light"
                                                    v-model="checked.ZipCode"
                                                ></v-text-field>
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.address.city'
                                                        )
                                                    "
                                                    multiple
                                                    class="input-bg-light"
                                                    v-model="checked.City"
                                                ></v-text-field>

                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.geoLocation'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="
                                                        checked.Coordinates
                                                    "
                                                />
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.plusCode'
                                                        )
                                                    "
                                                    class="input-bg-light"
                                                    v-model="checked.PlusCode"
                                                />
                                                <stc-google-map
                                                    :latLngStr="
                                                        checked.Coordinates
                                                    "
                                                    @updatedLatLngStr="
                                                        checked.Coordinates =
                                                            $event
                                                    "
                                                    @updatedPlusCode="
                                                        checked.PlusCode =
                                                            $event
                                                    "
                                                    class="map-placeholder"
                                                />
                                                <v-btn
                                                    small
                                                    color="primary"
                                                    class="mt-3 mx-2 w-auto"
                                                    type="button"
                                                    :disabled="loading"
                                                    style="
                                                        margin-top: 60px !important;
                                                    "
                                                    @click.stop="
                                                        updatePostalAddress(
                                                            checked
                                                        )
                                                    "
                                                    >{{
                                                        $t('button.text.update')
                                                    }}</v-btn
                                                >
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tabs>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import GoogleMap from '../components/map/GoogleMap.vue'
import { Constants } from '../constants.js'
import UserGroupsMixin from '../mixins/user-groups-mixin'
import RecipientsMixin from '../mixins/recipients-mixin'
import UnloadingAreasMixin from '../mixins/unloading-areas-mixin'
import FileUploadMixin from '../mixins/file-upload-mixin'
import FileGallery from '../components/waiting-area-tool/FileGallery.vue'

export default {
    name: 'containers-view',

    components: {
        'stc-google-map': GoogleMap,
        'stc-file-gallery': FileGallery,
    },

    mixins: [
        UserGroupsMixin,
        RecipientsMixin,
        UnloadingAreasMixin,
        FileUploadMixin,
    ],

    data() {
        return {
            loading: false,
            pageLoading: false,
            types: ['SLOT', 'PASS', 'BLC', 'WA'],
            bookingTimes: [
                { text: 'OFF', value: 0 },
                { text: '15min', value: 15 },
                { text: '30min', value: 30 },
                { text: '45min', value: 45 },
                { text: '60min', value: 60 },
                { text: '90min', value: 90 },
            ],
            checked: {
                ContainerID: '',
                ParentContainerID: '',
                Description: '',
                ContainerType: '',
                AvailableBookingTypes: [],
                MinimumBookingTime: '',
                IsBookingCanOverlapped: false,
                AutoPinEnabled: false,
                MaximumPassingsPerBooking: 0,
                Coordinates: Constants.DefaultGeoCoordinates,
                DefaultWATime: 0,
                CustomHeaderTextEn: null,
                CustomHeaderTextSv: null,
                CustomLogo: null,
                RecipientUserGroupID: null,
                RecipientUserID: null,
                UnloadingAreaID: null,
                AddressLine1: null,
                AddressLine2: null,
                ZipCode: null,
                City: null,
                PlusCode: null,
                DefaultCpAccessSchedule: null,
                DefaultWaitingArea: null,
            },
            editing: true,
            containerTypes: [],
            checkpointAccessSchedules: [],
            container: {
                show: false,
                nodeKey: 'ContainerID',
                defaultProps: {
                    children: 'Children',
                    label: 'Description',
                },
            },
            customFields: [],
            selfCheckinData: {
                customLogo: '',
                unloadingArea: null,
                user: null,
                userGroup: null,
            },
            isUserMode: 'user',
            selectedFiles: [],
            displayFiles: [],
            waitingAreas: [],
        }
    },

    watch: {
        async checked(newContainer, oldContainer) {
            if (newContainer.ContainerID === oldContainer.ContainerID) return

            this.pageLoading = true
            this.displayFiles = []
            this.selectedFiles = []
            Events.$emit('clear-images')

            const checkpointAccessScheduleResponse = await this.$http.get(
                `/Container/${newContainer.ContainerID}/ScheduleTemplate`
            )
            this.checkpointAccessSchedules =
                checkpointAccessScheduleResponse.data

            await this.fetchWaitingAreas(newContainer.ContainerID)
            this.setWaitingArea(newContainer.DefaultWaitingArea)

            await this.fetchContainerCustomFields(newContainer.ContainerID)
            await this.fetchUserGroups(newContainer)
            await this.getRecipients(newContainer)
            await this.getUnloadingAreas(newContainer)

            this.isUserMode = newContainer.RecipientUserGroupID
                ? 'userGroup'
                : 'user'
            this.selfCheckinData.user = null
            this.selfCheckinData.userGroup = null
            this.selfCheckinData.unloadingArea = null
            this.selfCheckinData.CustomLogo = null

            if (newContainer.RecipientUserID) {
                const filtered = this.recipients.filter(
                    (recipient) =>
                        recipient.UserID === newContainer.RecipientUserID
                )
                if (filtered && filtered.length > 0) {
                    this.selfCheckinData.user = filtered[0]
                }
            }

            if (newContainer.RecipientUserGroupID) {
                const filtered = this.userGroups.filter(
                    (userGroup) =>
                        userGroup.UserGroupID ===
                        newContainer.RecipientUserGroupID
                )
                if (filtered && filtered.length > 0) {
                    this.selfCheckinData.userGroup = filtered[0]
                }
            }

            if (newContainer.UnloadingAreaID) {
                const filtered = this.activeUnloadingAreas.filter(
                    (unloadingArea) =>
                        unloadingArea.UnloadingAreaID ===
                        newContainer.UnloadingAreaID
                )
                if (filtered && filtered.length > 0) {
                    this.selfCheckinData.unloadingArea = filtered[0]
                }
            }

            if (newContainer.CustomLogoName) {
                this.selfCheckinData.CustomLogo = newContainer.CustomLogoName
                this.displayFiles = newContainer.CustomLogoUrl
                    ? [
                          {
                              ImageId: newContainer.CustomLogoName,
                              ImageType: 'ContainerLogo',
                              ImagePath: newContainer.CustomLogoUrl,
                          },
                      ]
                    : []
            }
            this.pageLoading = false
        },
    },

    computed: {
        ...mapGetters([
            'containerTree',
            'selectedContainer',
            'permissions',
            'containers',
        ]),

        isSystemAdmin() {
            return this.permissions.includes('SYSTEM_ADMIN')
        },

        isCCCContainer() {
            return this.checked.ContainerType === 'CCC'
        },
    },

    mounted() {
        if (!this.permissions.includes('CONTAINER_WRITE')) {
            this.$router.replace({ name: 'dashboard' })
        }
        // get selected container with latest updated data
        const container = this.containers.filter(
            (container) =>
                container.ContainerID === this.selectedContainer.ContainerID
        )
        if (container && container.length > 0) {
            this.checked = _.cloneDeep(container[0])
        } else {
            this.checked = _.cloneDeep(this.selectedContainer)
        }

        Events.$on('file-removed', () => {
            this.selfCheckinData.customLogo = null
            this.displayFiles = []
            this.selectedFiles = []
            Events.$emit('clear-images')
        })
    },

    created() {
        this.fetchData()
    },

    methods: {
        async fetchData() {
            const { data } = await this.$http.get('/ContainerType')

            this.containerTypes = data
        },

        async fetchContainerCustomFields(containerId) {
            const { data } = await this.$http.get(
                `/container/${containerId}/ContainerCustomField`
            )

            this.customFields = data

            this.addCustomFiled(containerId)

            return new Promise((resolve) => resolve(data))
        },

        async saveCustomField(customField) {
            this.loading = true

            try {
                let method = 'post'
                let message = 'New custom field created successfully.'
                let url = `/container/${customField.ContainerID}/ContainerCustomField`

                if (customField.ContainerCustomFieldID) {
                    method = 'put'
                    message = 'Custom field updated successfully.'
                    url = `${url}/${customField.ContainerCustomFieldID}`
                }

                await this.$http[method](url, { ...customField })

                this.$message({
                    type: 'success',
                    showClose: true,
                    message,
                })

                this.fetchContainerCustomFields(customField.ContainerID)
            } catch (e) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message:
                        'Something went wrong. Please contact your administrator',
                })
            }

            this.loading = false
        },

        async removeCustomFiled(customField, index) {
            this.loading = true

            try {
                Vue.delete(this.customFields, index)

                if (
                    customField.hasOwnProperty('ContainerCustomFieldID') &&
                    customField.ContainerCustomFieldID != ''
                ) {
                    await this.$http.delete(
                        `/container/${customField.ContainerID}/ContainerCustomField/${customField.ContainerCustomFieldID}`
                    )
                }
                this.$message({
                    type: 'success',
                    showClose: true,
                    message: 'Custom field successfully deleted.',
                })
            } catch (error) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message:
                        'Something went wrong. Please contact your administrator',
                })
            }

            this.loading = false
        },

        reset() {
            this.checked.ContainerID = ''
            this.checked.ParentContainerID = ''
            this.checked.DefaultCpAccessSchedule = ''
            this.checked.Description = ''
            this.checked.DefaultWaitingArea = ''
            this.checked.ContainerType = ''
            this.checked.AvailableBookingTypes = []
            this.checked.MinimumBookingTime = ''
            this.checked.IsBookingCanOverlapped = false
            this.checkSelected.Coordinates = Constants.DefaultGeoCoordinates
        },

        checkSelected(container) {
            this.checked = _.cloneDeep(container)
            this.editing = true
        },

        startAddingNewContainer(data) {
            this.reset()
            this.checked.ParentContainerID = data.ContainerID
            this.editing = false
        },

        async addNewContainer() {
            this.loading = true

            try {
                await this.$http.post(`/Container`, this.checked)

                await this.$store.dispatch('fetchAllContainers')

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: 'New Container created.',
                })
            } catch (e) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: `${e.response.data}.`,
                })
            }

            this.loading = false
        },

        async updateContainer(container) {
            if (!container.DefaultWATime) container.DefaultWATime = 0
            if (!container.MaximumPassingsPerBooking)
                container.MaximumPassingsPerBooking = 0
            if (
                container.DefaultWaitingArea &&
                container.DefaultWaitingArea.WaitingAreaID
            ) {
                container.DefaultWaitingArea =
                    container.DefaultWaitingArea.WaitingAreaID
            }

            this.loading = true

            try {
                await this.$http.put(`/Container/${container.ContainerID}`, {
                    ...container,
                    LongName: 'LongName',
                    ShortName: 'ShortName',
                })
                this.setWaitingArea(container.DefaultWaitingArea)
                await this.$store.dispatch('fetchAllContainers')

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: 'Container settings updated.',
                })
            } catch (e) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: `${e.response.data}.`,
                })
            }

            this.loading = false
        },

        async deleteContainer(data) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: this.$i18n.i18next.t('form.label.container'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                await this.$http.delete(`/Container/${data.ContainerID}`)

                await this.$store.dispatch('fetchAllContainers')

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: this.$i18n.i18next.t('text.container'),
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        handleDrop(draggingNode, dropNode) {
            let container = { ...draggingNode.data }
            container.ParentContainerID = dropNode.data.ContainerID

            this.updateContainer(container)
        },

        addCustomFiled(containerId) {
            this.customFields.push({
                ContainerID: containerId,
                FieldName: '',
                FieldValue: '',
            })
        },

        async updateSelfCheckin(container, selfCheckinData) {
            this.loading = true
            try {
                if (this.selectedFiles && this.selectedFiles.length > 0) {
                    // Upload container logo
                    const response = await this.doUpload(
                        '/Util/UploadFiles/Container',
                        this.selectedFiles
                    )
                    if (
                        response &&
                        response[0] &&
                        response[0].data &&
                        response[0].data.ImageName
                    ) {
                        selfCheckinData.customLogo = response[0].data.ImageName
                        Events.$emit('clear-images')
                        this.selectedFiles = []
                        this.displayFiles = [
                            {
                                ImageId: response[0].data.ImageName,
                                ImageType: 'ContainerLogo',
                                ImagePath: response[0].data.URL,
                            },
                        ]
                    }
                }

                const payload = {
                    CustomHeaderTextEn: container.CustomHeaderTextEn,
                    CustomHeaderTextSv: container.CustomHeaderTextSv,
                    CustomLogo: selfCheckinData.customLogo,
                    RecipientUserID:
                        this.isUserMode === 'user' && selfCheckinData.user
                            ? selfCheckinData.user.UserID
                            : null,
                    RecipientUserGroupID:
                        this.isUserMode === 'userGroup' &&
                        selfCheckinData.userGroup
                            ? selfCheckinData.userGroup.UserGroupID
                            : null,
                    UnloadingAreaID: selfCheckinData.unloadingArea
                        ? selfCheckinData.unloadingArea.UnloadingAreaID
                        : null,
                    IsAllowedSelfCheckin: container.IsAllowedSelfCheckin,
                    ShowUnplannedDelivery: container.ShowUnplannedDelivery,
                }

                await this.$http.put(
                    `/Container/${container.ContainerID}/SelfCheckinSettings`,
                    payload
                )

                await this.updateContainer(container)

                await this.$store.dispatch('fetchAllContainers')

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: 'Container settings updated.',
                })
            } catch (e) {
                console.log(e)
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.error.general'),
                })
            }
            this.loading = false
            this.$nextTick(() => {
                this.$forceUpdate()
            })
        },

        async updatePostalAddress(container) {
            this.loading = true
            try {
                const payload = {
                    AddressLine1: container.AddressLine1,
                    AddressLine2: container.AddressLine2,
                    ZipCode: container.ZipCode,
                    City: container.City,
                    PlusCode: container.PlusCode,
                    Coordinates: container.Coordinates,
                }

                await this.$http.put(
                    `/Container/${container.ContainerID}/PostalAddress`,
                    payload
                )

                await this.$store.dispatch('fetchAllContainers')

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: 'Container settings updated.',
                })
            } catch (e) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.error.general'),
                })
            }
            this.loading = false
        },

        onSelectedFiles(files) {
            this.selectedFiles = files
        },

        async fetchWaitingAreas(containerId) {
            if (!this.isCCCContainer) {
                const blcContainer = await this.getBlcContainer(containerId)
                if (blcContainer && blcContainer.ContainerID) {
                    let { data } = await this.$http.get(
                        `WaitingArea/${blcContainer.ContainerID}`
                    )
                    this.waitingAreas = data
                }
            }
        },

        async getBlcContainer(containerId) {
            let { data } = await this.$http.get(`Container/${containerId}/BLC`)
            return data
        },

        setWaitingArea(defaultWaitingArea) {
            if (defaultWaitingArea) {
                const waitingArea = this.waitingAreas.filter(
                    (waitingArea) =>
                        waitingArea.WaitingAreaID == defaultWaitingArea
                )
                if (waitingArea && waitingArea.length > 0) {
                    this.checked.DefaultWaitingArea = waitingArea[0]
                }
            }
        },
    },
}
</script>
<style scoped>
.map-placeholder {
    height: 250px;
}
</style>
<style>
.application .theme--dark.input-group input,
.application .theme--dark.input-group textarea,
.theme--dark .input-group input,
.theme--dark .input-group textarea {
    color: #000000;
}

.application
    .theme--dark.input-group.input-group--dirty
    .input-group__selections__comma:not(
        .input-group__selections__comma--active
    ),
.theme--dark
    .input-group.input-group--dirty
    .input-group__selections__comma:not(
        .input-group__selections__comma--active
    ) {
    color: #000000;
}
</style>